var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_title",class:{'small': _vm.small}},[_c('span',{staticClass:"jpn"},[_vm._v(_vm._s(_vm.jpn))])])
}
var staticRenderFns = []

export { render, staticRenderFns }